// Partners are fetched dynamically from the API
// This file exports an empty array since partners are managed in the Vuex store
export default [
  {
    key: 'scorestream',
    category: 'partner',
    element: 'scorestream',
    title: 'ScoreStream',
    logo: '/img/scorestream.svg',
    description: 'High school and local sports scores, powered by ScoreStream',
    test: 'scorestream',
  },
  {
    key: 'foxforesight',
    category: 'partner',
    element: 'foxforesight',
    title: 'Fox Foresight',
    logo: '/img/fox-foresight.svg',
    description: 'Advanced baseball analytics powered by Fox Foresight',
    test: 'foxforesight',
    requiresPermission: 'hasFoxForesight',
  },
];
